import { createContext } from "react";

export const RequiredMarkContext = createContext(false);
